import defaultSettings from '@/settings'
import i18n from '@/lang'
import store from '../store/index'

let title = defaultSettings.title

export default function getPageTitle(key) {
  const hasKey = i18n.te(`route.${key}`)
  if (store.state.user.privateConfig.privateName) {
    title = store.state.user.privateConfig.privateName
  }
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${title}`
  }
  return `${title}`
}
